import React from 'react';
import { REBRAND_COLOR } from '@latitude/core/utils/constants';
import {
  StyledPromoBannerContainer,
  StyledImageContainer,
  StyledTextContainer,
  Wrapper
} from './PromoBannerRebrand.styled';
import { Typography } from '@latitude/typography';
import Button from '@latitude/button-rebrand';

const COMPONENT_ID = 'promo-banner-rebrand';

/**
 * PromoBannerRebrand component
 */
const PromoBanner = ({
  tag,
  logoImage,
  bgColor,
  isReversed,
  tcText,
  heading,
  description,
  image,
  button,
  fullWidth,
  trackingId,
  ...rest
}) => {
  const componentIdentifier = trackingId
    ? `${trackingId}-${COMPONENT_ID}`
    : COMPONENT_ID;

  return (
    <Wrapper className={componentIdentifier} {...rest} background={bgColor}>
    <StyledPromoBannerContainer isReversed={isReversed}>
      <StyledTextContainer className={`${componentIdentifier}-text-container`} fullWidth={fullWidth}>
        {tag && <Typography.Body small>
          {tag}
        </Typography.Body>}
        {logoImage && <img src={logoImage} alt={heading} />}
        <Typography.SH1 semibold>{heading}</Typography.SH1>
         <Typography.Body semibold color={REBRAND_COLOR.BLACK_80}>
          {description}
        </Typography.Body>
        <Button
          className={`${componentIdentifier}-cta`}
          variant={button?.variant}
          size={button?.size}
          ctaText={button?.text}
          ctaUrl={button?.url}
          trackEventData={{
            category: 'text-link',
            location: `promo-${heading}`,
            label: button?.text
          }}
          trackId={COMPONENT_ID}
        />
        <Typography.Body small color={REBRAND_COLOR.BLACK_80}>
        {tcText}
        </Typography.Body>
      </StyledTextContainer>
      <StyledImageContainer
        className={`${componentIdentifier}-image-container`}
        fullWidth={fullWidth}
      >
        <img src={image} alt={heading} />
      </StyledImageContainer>
    </StyledPromoBannerContainer>
    </Wrapper>
  );
};

export default PromoBanner;
